/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Resume_Current_PageInputs */

const en_kindle_resume_current_page = /** @type {(inputs: Kindle_Resume_Current_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your saved passage is not on this page. Listening from Kindle’s current page.`)
};

const es_kindle_resume_current_page = /** @type {(inputs: Kindle_Resume_Current_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pasaje guardado no está en esta página. Escuchando desde la página actual de Kindle.`)
};

/**
* | output |
* | --- |
* | "Your saved passage is not on this page. Listening from Kindle’s current page." |
*
* @param {Kindle_Resume_Current_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_resume_current_page = /** @type {((inputs?: Kindle_Resume_Current_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Resume_Current_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_resume_current_page(inputs)
	return en_kindle_resume_current_page(inputs)
});